<template>
  <CustomModal ref="modal" class="add-amendment-modal" title="Créer un avenant">
    <div>
      <CustomForm ref="form" :inputs=inputs :submit=buttons.submit>
        <div class="form-container">
          <div class="element">
            <CustomTextField class="title" :content=inputs.title />
            <CustomSelectField :content=inputs.quoteValidityPeriod />
            <CustomSelectField style="margin-top: 15px" :content=inputs.invoicePaiementPeriod />
            <CustomTextAreaField :content=inputs.bank  style="height: 100px"/>
            <CustomTextAreaField :content=inputs.additionalInformation  style="height: 100px"/>
          </div>
        </div>
        <CustomButton class="submit-button" @click="submitForm" :params=buttons.submit style="margin-top: 15px"/>
      </CustomForm>
    </div>
  </CustomModal>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark, faPlus, faUpLong, faCheck, faExclamation } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "@/components/forms/customs/customButton/CustomButton.vue";
import CustomTextField from "@/components/forms/customs/customTextField/CustomTextField.vue";
import CustomSelectField from "@/components/forms/customs/customSelectField/CustomSelectField.vue";
import {NotificationService} from "@vues/v-common";
import {BusinessController} from "@/controllers/business/BusinessController";
import CustomForm from "@/components/forms/CustomForm.vue";
import CustomModal from "@/components/modals/CustomModal.vue";
import CustomTextAreaField from "@/components/forms/customs/customTextAreaField/CustomTextAreaField.vue";
library.add(faXmark);
library.add(faPlus);
library.add(faCheck);
library.add(faUpLong);
library.add(faExclamation);

  export default {
      name: 'AddAmendmentModal',
      props: ['callback'],
      components: {CustomTextAreaField, CustomModal, CustomForm, CustomSelectField, CustomTextField, CustomButton},
      data() {
          return {
            business: undefined,
            documentName: "test",
            inputs: {
              title: {label: 'Titre', value: '', type: 'text', required: true},
              bank: {label: 'Coordonnées bancaires', value: '', required: true},
              additionalInformation: {label: 'Informations complémentaires', value: ''},
              quoteValidityPeriod: {label: 'Période de validité', value: '', type: 'select', selectValues: [{label:"45", value: 45}, {label:"30", value: 30}, {label:"15", value: 15}], required: true},
              invoicePaiementPeriod: {label: 'Délai de paiement', value: '', type: 'select', selectValues: [{label:"45", value: 45}, {label:"30", value: 30}, {label:"15", value: 15}, {label:"A la réception", value: 0}], required: true},
            },
            buttons:{
              submit: {text: "Créer l'avenant"}
            },
            isTerminateButtonDisplayed: false
          };
      },
      methods: {
        async openModal(business) {
          this.$refs.modal.openModal();
          this.$refs.form?.startLoading();
          this.business = business;
          this.buttons.submit.disabled = false;
          this.inputs.title.value = "Avenant - " + business.title;
          this.inputs.bank.value = business.bank;
          this.inputs.additionalInformation.value = business.additionalInformation;

          this.inputs.quoteValidityPeriod.value = business.quoteValidityPeriod;
          this.inputs.invoicePaiementPeriod.value = business.invoicePaiementPeriod;
          this.$refs.form?.stopLoading();
        },
        closeModal() {
          this.$refs.modal?.closeModal();
        },
        terminate(){
          this.closeModal();
          this.callback();
        },
        async submitForm() {
          const res = await this.$refs.form.submitForm(() => BusinessController.postAmendment({
            title : this.inputs.title.value,
            quoteValidityPeriod : this.inputs.quoteValidityPeriod.value,
            invoicePaiementPeriod : this.inputs.invoicePaiementPeriod.value,
            bank : this.inputs.bank.value,
            additionalInformation : this.inputs.additionalInformation.value,
            amendmentOfBusinessId : this.business.id,
          }));
          if (!res.errors) {
            (new NotificationService).addNotification("success", "Contrat ajouté");
            this.terminate();
          }
        }
      }
  }

</script>

<style lang="stylus" scoped>
    @require '~/src/common/style/common.styl';

    .form-container
      display flex
      flex-direction column

    .submit-button
      margin 20px auto auto

    @media only screen and (min-width: DESKTOP_SIZE)
      .form-container
        flex-direction row
        .element
          width: calc(100% - 4em)
          padding 2em

      .submit-button
        width 250px
</style>

<style lang="stylus">
  .add-amendment-modal .modal
    width 500px !important
</style>